"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDDVariableForm = void 0;
const react_1 = __importStar(require("react"));
const client_1 = require("@apollo/client");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const edd_variable_form_validation_1 = require("./edd-variable-form.validation");
const polaris_1 = require("@shopify/polaris");
const polaris_icon_component_1 = require("@/common/components/polaris-icon/polaris-icon.component");
const text_1 = require("@/common/components/text");
const AccountContext_1 = require("contexts/AccountContext");
const helpers_1 = require("@/common/helpers");
const edd_variable_form_graphql_1 = require("./edd-variable-form.graphql");
const hooks_1 = require("@/edd/common/hooks");
const CARD_OPTIONS = {
    new: {
        textVariant: 'headingSm',
        iconStyle: 'add',
        icon: polaris_icon_component_1.iconSources.add
    },
    edit: {
        textVariant: 'bodyMd',
        iconStyle: 'edit',
        icon: polaris_icon_component_1.iconSources.edit
    },
    delete: {
        textVariant: 'bodyMd',
        iconStyle: 'delete',
        icon: polaris_icon_component_1.iconSources.delete
    }
};
const NEW_VARIABLE = {
    name: '',
    minDays: '1',
    maxDays: '3',
    type: 'NEW'
};
const EDDVariableForm = ({ mode = 'edit', variable, show, onFormDelete, onFormSuccess, onFormCardToggle }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { account } = (0, AccountContext_1.useAccount)();
    const [isDeleteModalActive, setIsDeleteModalActive] = (0, react_1.useState)(false);
    const [showDeleteButton, setShowDeleteButton] = (0, react_1.useState)(false);
    const { refetch: refetchVariables } = (0, hooks_1.useEDDVariables)();
    const { control, formState: { isValid, errors }, handleSubmit, reset, setValue, setError, watch, trigger } = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        reValidateMode: 'onChange',
        defaultValues: variable || NEW_VARIABLE,
        resolver: (0, zod_1.zodResolver)(edd_variable_form_validation_1.variableFormSchema)
    });
    const values = watch();
    const toggleDeleteModal = (0, react_1.useCallback)(() => setIsDeleteModalActive(!isDeleteModalActive), [isDeleteModalActive]);
    const [createEDDVariable, { loading: loadingCreateVariable }] = (0, client_1.useMutation)(edd_variable_form_graphql_1.CREATE_EDD_VARIABLE, {
        onCompleted: ({ createEstimatedDeliveryDateVariable: { estimatedDeliveryDateVariable } }) => {
            const variableName = estimatedDeliveryDateVariable.name;
            handleSuccessfulFormSubmission();
            onFormSuccess(`Successfully created the new '${variableName}' variable.`);
        },
        onError(errorDetail) {
            handleGraphQLErrors(errorDetail);
        }
    });
    const [deleteEDDVariable] = (0, client_1.useMutation)(edd_variable_form_graphql_1.DELETE_EDD_VARIABLE, {
        onCompleted: () => {
            handleSuccessfulFormSubmission();
        },
        onError: (errorDetail) => {
            if (onFormDelete) {
                onFormDelete({ content: errorDetail.message, type: 'error' });
            }
        }
    });
    const [updateEDDVariable, { loading: loadingUpdateVariable }] = (0, client_1.useMutation)(edd_variable_form_graphql_1.UPDATE_EDD_VARIABLE, {
        onCompleted: ({ updateEstimatedDeliveryDateVariable: { estimatedDeliveryDateVariable } }) => {
            const variableName = estimatedDeliveryDateVariable.name;
            handleSuccessfulFormSubmission();
            onFormSuccess(`Successfully updated the '${variableName}' variable.`);
        },
        onError: (errorDetail) => {
            handleGraphQLErrors(errorDetail);
        }
    });
    (0, react_1.useEffect)(() => {
        // when form is opened, set fixedDate checkbox correctly
        if (show) {
            values.maxDays
                ? setValue('fixedDate', false)
                : setValue('fixedDate', true);
        }
    }, [show]);
    (0, react_1.useEffect)(() => {
        if (variable && !variable.reserved) {
            setShowDeleteButton(true);
        }
    }, [variable]);
    (0, react_1.useEffect)(() => {
        // Zod validation for min/max range triggers on minDays
        // This effect watch also triggers it on maxDays
        trigger('minDays');
    }, [values.maxDays, values.fixedDate, trigger]);
    (0, react_1.useEffect)(() => {
        if (!values.fixedDate) {
            // validate maxDays when it gets re-enabled
            trigger('maxDays');
        }
    }, [values.fixedDate, trigger]);
    if (!show) {
        return renderVariableSummaryCard();
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        renderVariableSummaryCard(),
        react_1.default.createElement(polaris_1.Form, { noValidate: true, onSubmit: handleSubmit(onSubmit) },
            react_1.default.createElement(polaris_1.Card, null,
                react_1.default.createElement(polaris_1.BlockStack, { gap: '400' },
                    react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
                        react_1.default.createElement(polaris_1.Box, { width: '260px' },
                            react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'name', render: (_a) => {
                                    var _b = _a.field, { value, ref: _ref } = _b, rest = __rest(_b, ["value", "ref"]);
                                    return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', "data-test": 'edd-variable-form-name', error: !!errors.name, id: 'edd-variable-form-name', inputMode: 'text', label: react_1.default.createElement(polaris_1.Text, { as: 'h3', variant: 'headingSm' }, "Variable name"), labelHidden: false, maxLength: 300, prefix: '{{', readOnly: variable === null || variable === void 0 ? void 0 : variable.reserved, suffix: '}}', type: 'text', value: value.replace(/[^A-Za-z0-9_]/g, '') })));
                                } })),
                        ((_a = errors.name) === null || _a === void 0 ? void 0 : _a.message) && (react_1.default.createElement(polaris_1.InlineError, { fieldID: 'name', message: (_b = errors.name) === null || _b === void 0 ? void 0 : _b.message }))),
                    react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
                        react_1.default.createElement(polaris_1.Box, null,
                            react_1.default.createElement(polaris_1.Text, { as: 'h3', variant: 'headingSm' }, "Time in transit"),
                            react_1.default.createElement(polaris_1.Text, { as: 'p', variant: 'bodyMd' }, "Time from fulfillment to delivered.")),
                        react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
                            react_1.default.createElement(polaris_1.InlineStack, { align: 'start', blockAlign: 'center', gap: '300' },
                                react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'minDays', render: (_a) => {
                                        var _b = _a.field, { value, ref: _ref } = _b, rest = __rest(_b, ["value", "ref"]);
                                        return (react_1.default.createElement(polaris_1.Box, { width: '70px' },
                                            react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', id: 'edd-variable-form-minDays', inputMode: 'numeric', label: 'minDays', labelHidden: true, type: 'integer', value: value }))));
                                    } }),
                                react_1.default.createElement(polaris_1.Text, { as: 'span', variant: 'bodyMd' }, ' to '),
                                react_1.default.createElement(polaris_1.Box, { width: '70px' },
                                    react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'maxDays', render: (_a) => {
                                            var _b = _a.field, { value, ref: _ref } = _b, rest = __rest(_b, ["value", "ref"]);
                                            return (react_1.default.createElement(polaris_1.TextField, Object.assign({}, rest, { autoComplete: 'off', disabled: values.fixedDate, id: 'edd-variable-form-maxDays', inputMode: 'numeric', label: 'maxDays', labelHidden: true, type: 'integer', value: value || '' })));
                                        } })),
                                react_1.default.createElement(polaris_1.Text, { as: 'span', variant: 'bodyMd' }, ' days')),
                            react_1.default.createElement(polaris_1.BlockStack, { gap: '200' },
                                ((_c = errors === null || errors === void 0 ? void 0 : errors.minDays) === null || _c === void 0 ? void 0 : _c.message) && (react_1.default.createElement(polaris_1.InlineError, { fieldID: 'minDays', message: (_d = errors === null || errors === void 0 ? void 0 : errors.minDays) === null || _d === void 0 ? void 0 : _d.message })),
                                ((_e = errors === null || errors === void 0 ? void 0 : errors.maxDays) === null || _e === void 0 ? void 0 : _e.message) && (react_1.default.createElement(polaris_1.InlineError, { fieldID: 'maxDays', message: (_f = errors === null || errors === void 0 ? void 0 : errors.maxDays) === null || _f === void 0 ? void 0 : _f.message })))),
                        react_1.default.createElement(react_hook_form_1.Controller, { control: control, name: 'fixedDate', render: (_a) => {
                                var _b = _a.field, { value, ref: _ref } = _b, rest = __rest(_b, ["value", "ref"]);
                                return (react_1.default.createElement(polaris_1.Checkbox, Object.assign({}, rest, { checked: value, id: 'edd-variable-form-fixedDate', label: 'Fixed date' })));
                            } })),
                    react_1.default.createElement(polaris_1.InlineStack, { gap: '200' },
                        react_1.default.createElement(polaris_1.Button, { onClick: handleCancelForm, variant: 'secondary' }, "Cancel"),
                        react_1.default.createElement(polaris_1.Button, { disabled: !isValid, loading: loadingCreateVariable || loadingUpdateVariable, submit: true, variant: 'primary' }, "Save variable")),
                    ((_h = (_g = errors === null || errors === void 0 ? void 0 : errors.root) === null || _g === void 0 ? void 0 : _g.serverError) === null || _h === void 0 ? void 0 : _h.message) && (react_1.default.createElement(polaris_1.InlineError, { fieldID: 'submit', message: formatErrorMessage(errors.root.serverError.message) })))))));
    function renderVariableSummaryCard() {
        const text = mode === 'new' || !variable
            ? 'Add a new estimated delivery date range'
            : formatVariableDesc();
        return (react_1.default.createElement("span", { id: `${variable === null || variable === void 0 ? void 0 : variable.name}-summary-card` },
            react_1.default.createElement(polaris_1.Card, null,
                react_1.default.createElement(polaris_1.InlineStack, { align: 'space-between', blockAlign: 'center' },
                    react_1.default.createElement(polaris_1.Text, { as: 'p', variant: CARD_OPTIONS[mode].textVariant }, text),
                    react_1.default.createElement(polaris_1.InlineStack, { align: 'center', blockAlign: 'baseline', gap: '100' },
                        react_1.default.createElement("span", { className: mode === 'new'
                                ? 'edd-add-new-variable-button'
                                : 'edd-edit-button' },
                            react_1.default.createElement(polaris_1.Button, { icon: CARD_OPTIONS[mode].icon, onClick: onFormCardToggle, variant: 'plain' })),
                        showDeleteButton && (react_1.default.createElement(polaris_1.Modal, { activator: react_1.default.createElement("span", { className: 'edd-delete-variable-button' },
                                react_1.default.createElement(polaris_1.Button, { icon: CARD_OPTIONS.delete.icon, onClick: toggleDeleteModal, variant: 'plain' })), onClose: toggleDeleteModal, open: isDeleteModalActive, primaryAction: {
                                content: 'Delete',
                                destructive: true,
                                onAction: handleDelete
                            }, secondaryActions: [
                                {
                                    content: 'Cancel',
                                    onAction: toggleDeleteModal
                                }
                            ], title: 'Confirm Delete' },
                            react_1.default.createElement(polaris_1.Modal.Section, null,
                                react_1.default.createElement("p", null, `Are you sure you want to delete the variable ${variable === null || variable === void 0 ? void 0 : variable.name}?`)))))))));
    }
    function formatErrorMessage(errorMessage) {
        return `Error: ${errorMessage.replace(/_/g, ' ')}`;
    }
    function formatVariableDesc() {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(text_1.Highlight, null, `{{${variable === null || variable === void 0 ? void 0 : variable.name}}}`),
            " =",
            ' ', variable === null || variable === void 0 ? void 0 :
            variable.description));
    }
    function handleCancelForm() {
        return __awaiter(this, void 0, void 0, function* () {
            onFormCardToggle();
        });
    }
    function handleDelete() {
        return __awaiter(this, void 0, void 0, function* () {
            const currentVariableName = variable === null || variable === void 0 ? void 0 : variable.name;
            if (account && variable) {
                yield deleteEDDVariable({
                    variables: {
                        input: {
                            accountId: account.id,
                            variableId: variable.id
                        }
                    }
                });
                if (onFormDelete) {
                    onFormDelete({
                        content: `Successfully deleted the '${currentVariableName}' variable.`,
                        type: 'success'
                    });
                }
            }
        });
    }
    function handleGraphQLErrors(error) {
        const formattedErrors = (0, helpers_1.formatGraphqlErrors)(error);
        formattedErrors === null || formattedErrors === void 0 ? void 0 : formattedErrors.forEach((errorDetail) => {
            setError(errorDetail[0], errorDetail[1]);
        });
    }
    function handleSuccessfulFormSubmission() {
        return __awaiter(this, void 0, void 0, function* () {
            refetchVariables();
            reset(variable);
            onFormCardToggle();
        });
    }
    function onSubmit(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const type = data.fixedDate ? 'DATE' : 'DATE_RANGE';
            const variableData = {
                name: data.name,
                type,
                minDays: data.minDays
            };
            if (type === 'DATE_RANGE' && !data.fixedDate && data.maxDays) {
                variableData.maxDays = data.maxDays;
            }
            if (account) {
                if (variable === null || variable === void 0 ? void 0 : variable.id) {
                    yield updateEDDVariable({
                        variables: {
                            input: {
                                accountId: account.id,
                                variableId: variable.id,
                                variable: JSON.stringify(variableData)
                            }
                        }
                    });
                }
                else {
                    yield createEDDVariable({
                        variables: {
                            input: {
                                accountId: account.id,
                                variable: JSON.stringify(variableData)
                            }
                        }
                    });
                }
            }
        });
    }
};
exports.EDDVariableForm = EDDVariableForm;
